<div class="web">
  <div class="fotografiaContainer">
    <div class="fotografiaCenter">
      <div id="pf-1" class="container-fluid p-0" style="margin-top: 0px">
        <div class="row p-0">
          <div class="col-sm-12 p-0">
            <div class="titulo-seccion-cinta">
              <h2>Fotografías</h2>
            </div>
          </div>
        </div>
        <div id="pf-2" class="row p-0 m-0">
          <div id="pf-3" class="col-sm-12 p-0 mt-1">
            <div
              id="pf-4"
              class="container-fluid p-0 m-0"
              style="box-sizing: border-box"
            >
              <div id="pf-5" class="row p-0 m-0" style="box-sizing: border-box">
                <div class="contenedor-galeria">
                  <div class="columna-galeria" *ngFor="let columna of columnas">
                    <div class="item-galeria" *ngFor="let item of columna">
                      <div
                        class="panelFotografiaWeb"
                        [routerLink]="['/dt', generateSlug(item.title), item.id]"
                        style="cursor: pointer"
                      >
                        <div class="col-sm-6 p-0" style="margin-top: 0">
                          <div class="marco-container">
                            <div class="imagen-container-holografico">
                              <ng-container *ngIf="!shouldShowSkeleton(item.activoId)">
                                <img *ngIf="getProtectedImageUrl(item.activoId)"
                                     class="img-fluid-sin-marco"
                                     [src]="getProtectedImageUrl(item.activoId)"
                                     width="100%"
                                     style="padding: 0; "
                                     alt="{{ item.title }} - Imagen Protegida">
                              </ng-container>
                              <app-image-skeleton
                                *ngIf="shouldShowSkeleton(item.activoId)"
                                width="100%"
                                height="auto"
                                size="medium"
                                [isResponsive]="true"
                                [class]="'img-fluid-sin-marco ' + getSkeletonOrientationClass(item.activoId)"
                                >
                              </app-image-skeleton>
                            </div>
                          </div>

                          <!-- Ver detalle completo debajo de la imagen -->
                          <div class="ver-mas-indicator">
                            <span>Ver detalle completo</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M5.5 7a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L11.293 7H5.5z"/>
                            </svg>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 text-left"
                          style="padding: 0 0 0 10px"
                        >
                          <p class="tituloFoto">{{ item.title }}</p>
                          <p class="subtituloFoto">{{ item.subtitle }}</p>
                          <p></p>
                          <!-- <p class="precioFoto">S/ {{item.price}}</p> -->
                          <p class="descripcionFoto">{{ item.description }}</p>
                          <!-- <p>id: {{ item.activoId }} 55555555</p> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin: 0; padding: 0">
          <div class="col-sm-12" style="margin: 0; padding: 0">
            <p
              style="
                margin: 0px;
                padding: 0;
                margin-top: 39px;
                margin-bottom: 46px;
              "
            >
              <span
                class="verMasFotografia verMasBordeFotografia"
                [routerLink]="['/fotografias']"
              >
                VER MÁS
              </span>
            </p>
          </div>
        </div>
        <div class="col-sm-12 mt-4 mb-5">
          <div
            style="width: 100%; height: 1px; background-color: #a5a5a5"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="movil">
  <div class="fotografiaContainerM">
    <div class="fotografiaCenterM">
      <div id="pfm-1" class="container-fluid p-0 m-0" style="margin-top: 0px">
        <div class="row p-0">
          <div class="col-12 p-0">
            <p style="padding-top: 10px; margin-top: 10px; margin-bottom: 0">
              <span class="tituloPanelFotoM tituloBordePanelFotoM"
                >Fotografías</span
              >
            </p>
            <p style="margin: 8px">
              <span class="subTituloFotografiaM">
                <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed facere sit.8<br/> Labore architecto eligendi omnis quas eius! -->
              </span>
            </p>
          </div>
        </div>
        <div id="pfm-2" class="row p-0 m-0 w-100">
          <div id="pfm-3" class="col-12 p-0 mt-1">
            <div
              id="pfm-4"
              class="container-fluid p-0 m-0"
              style="box-sizing: border-box"
            >
              <div
                id="pfm-5"
                class="row p-0 m-0 w-100"
                style="box-sizing: border-box"
              >
                <div
                  id="pfm-6"
                  class="col-12 col-md-6 p-0"
                  *ngFor="let item of listFotografias.response.list"
                >
                  <div id="pfm-7" class="container-fluid p-0">
                    <div id="pfm-8" class="row p-0 m-1">
                      <div class="panelFotografiaMovil" [routerLink]="['/dt', generateSlug(item.title), item.id]" style="cursor: pointer;">
                        <div class="col-6 p-0" style="margin-top: 0">
                          <div class="marco-container">
                            <div class="">
                              <ng-container *ngIf="!shouldShowSkeleton(item.activoId)">
                                <img *ngIf="getProtectedImageUrl(item.activoId)"
                                     class="img-fluid-sin-marco"
                                     [src]="getProtectedImageUrl(item.activoId)"
                                     style="padding: 0;"
                                     alt="{{ item.title }} - Imagen Protegida">
                              </ng-container>
                              <app-image-skeleton
                                *ngIf="shouldShowSkeleton(item.activoId)"
                                width="100%"
                                height="auto"
                                size="medium"
                                [isResponsive]="true"
                                [class]="'img-fluid ' + getSkeletonOrientationClass(item.activoId)">
                              </app-image-skeleton>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-6 text-left"
                          style="padding: 0 0 0 10px"
                        >
                          <p class="tituloFoto">{{ item.title }}</p>
                          <p class="descripcionFoto">{{ item.subtitle }}</p>
                          <p></p>
                          <!-- <p class="precioFoto">S/ {{item.price}}</p> -->
                          <p class="descripcionFoto">{{ item.description }}</p>
                          <!-- <p>id: {{ item.activoId }}</p> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 20px">
          <div class="col-sm-12" style="padding: 0">
            <p
              style="
                margin: 0px;
                padding: 0;
                margin-top: 39px;
                margin-bottom: 46px;
              "
            ></p>
            <p style="margin-top: 8px; margin-bottom: 0">
              <span
                class="verMasFotografiaM verMasBordeFotografiaM"
                [routerLink]="['/fotografias']"
              >
                VER MÁS
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
